// extracted by mini-css-extract-plugin
module.exports = {"clh8ud0":"clh8ud0"};